import {CelestialBodyType, CelestialBody} from '../scene.model';

export const CORDELIA: CelestialBody = {
  id: 'cordelia',
  position: {
    x: 0,
    y: 0
  },
  mass: 4.4e16,
  radius: 20,
  semiMajorAxis: 49770,
  eccentricity: 0.00026,
  trueAnomaly: 0,
  meanAnomaly: 254.8,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const OPHELIA: CelestialBody = {
  id: 'ophelia',
  position: {
    x: 0,
    y: 0
  },
  mass: 5.3e16,
  radius: 21.5,
  semiMajorAxis: 53790,
  eccentricity: 0.00992,
  trueAnomaly: 0,
  meanAnomaly: 116.3,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const BIANCA: CelestialBody = {
  id: 'bianca',
  position: {
    x: 0,
    y: 0
  },
  mass: 9.2e16,
  radius: 25.5,
  semiMajorAxis: 59170,
  eccentricity: 0.00092,
  trueAnomaly: 0,
  meanAnomaly: 138.5,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const CRESSIDA: CelestialBody = {
  id: 'cressida',
  position: {
    x: 0,
    y: 0
  },
  mass: 34e16,
  radius: 40,
  semiMajorAxis: 61780,
  eccentricity: 0.00036,
  trueAnomaly: 0,
  meanAnomaly: 233.8,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const DESDEMONA: CelestialBody = {
  id: 'desdemona',
  position: {
    x: 0,
    y: 0
  },
  mass: 18e16,
  radius: 32,
  semiMajorAxis: 62680,
  eccentricity: 0.00013,
  trueAnomaly: 0,
  meanAnomaly: 184.6,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const JULIET: CelestialBody = {
  id: 'juliet',
  position: {
    x: 0,
    y: 0
  },
  mass: 56e16,
  radius: 47,
  semiMajorAxis: 64350,
  eccentricity: 0.00066,
  trueAnomaly: 0,
  meanAnomaly: 244.7,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const PORTIA: CelestialBody = {
  id: 'portia',
  position: {
    x: 0,
    y: 0
  },
  mass: 170e16,
  radius: 67.5,
  semiMajorAxis: 66090,
  eccentricity: 0.00005,
  trueAnomaly: 0,
  meanAnomaly: 218.3,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const ROSALIND: CelestialBody = {
  id: 'rosalind',
  position: {
    x: 0,
    y: 0
  },
  mass: 25e16,
  radius: 36,
  semiMajorAxis: 69940,
  eccentricity: 0.00011,
  trueAnomaly: 0,
  meanAnomaly: 136.1,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const CUPID: CelestialBody = {
  id: 'cupid',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.38e16,
  radius: 9,
  semiMajorAxis: 74800,
  eccentricity: 0.0013,
  trueAnomaly: 0,
  meanAnomaly: 163.8,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const BELINDA: CelestialBody = {
  id: 'belinda',
  position: {
    x: 0,
    y: 0
  },
  mass: 49e16,
  radius: 45,
  semiMajorAxis: 75260,
  eccentricity: 0.00007,
  trueAnomaly: 0,
  meanAnomaly: 357.2,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const PERDITA: CelestialBody = {
  id: 'perdita',
  position: {
    x: 0,
    y: 0
  },
  mass: 1.8e16,
  radius: 15,
  semiMajorAxis: 76400,
  eccentricity: 0.0012,
  trueAnomaly: 0,
  meanAnomaly: 192.4,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const PUCK: CelestialBody = {
  id: 'puck',
  position: {
    x: 0,
    y: 0
  },
  mass: 290e16,
  radius: 81,
  semiMajorAxis: 86010,
  eccentricity: 0.00012,
  trueAnomaly: 0,
  meanAnomaly: 245.8,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const MAB: CelestialBody = {
  id: 'mab',
  position: {
    x: 0,
    y: 0
  },
  mass: 1.0e16,
  radius: 12.5,
  semiMajorAxis: 97700,
  eccentricity: 0.0025,
  trueAnomaly: 0,
  meanAnomaly: 273.8,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const MIRANDA: CelestialBody = {
  id: 'miranda',
  position: {
    x: 0,
    y: 0
  },
  mass: 6590e16,
  radius: 235.8,
  semiMajorAxis: 129390,
  eccentricity: 0.0013,
  trueAnomaly: 0,
  meanAnomaly: 311.3,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const ARIEL: CelestialBody = {
  id: 'ariel',
  position: {
    x: 0,
    y: 0
  },
  mass: 135300e16,
  radius: 578.9,
  semiMajorAxis: 191020,
  eccentricity: 0.0012,
  trueAnomaly: 0,
  meanAnomaly: 39.5,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const UMBRIEL: CelestialBody = {
  id: 'umbriel',
  position: {
    x: 0,
    y: 0
  },
  mass: 117200e16,
  radius: 584.7,
  semiMajorAxis: 266300,
  eccentricity: 0.0039,
  trueAnomaly: 0,
  meanAnomaly: 12.5,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const TITANIA: CelestialBody = {
  id: 'titania',
  position: {
    x: 0,
    y: 0
  },
  mass: 352700e16,
  radius: 788.4,
  semiMajorAxis: 435910,
  eccentricity: 0.0011,
  trueAnomaly: 0,
  meanAnomaly: 24.6,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const OBERON: CelestialBody = {
  id: 'oberon',
  position: {
    x: 0,
    y: 0
  },
  mass: 301400e16,
  radius: 761.4,
  semiMajorAxis: 583520,
  eccentricity: 0.0014,
  trueAnomaly: 0,
  meanAnomaly: 283.1,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const FRANCISCO: CelestialBody = {
  id: 'francisco',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.72e16,
  radius: 11,
  semiMajorAxis: 4282900,
  eccentricity: 0.1324,
  trueAnomaly: 0,
  meanAnomaly: 90.9,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const CALIBAN: CelestialBody = {
  id: 'caliban',
  position: {
    x: 0,
    y: 0
  },
  mass: 7.0e16,
  radius: 21,
  semiMajorAxis: 7231100,
  eccentricity: 0.1812,
  trueAnomaly: 0,
  meanAnomaly: 163.5,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const STEPHANO: CelestialBody = {
  id: 'stephano',
  position: {
    x: 0,
    y: 0
  },
  mass: 2.2e16,
  radius: 16,
  semiMajorAxis: 8007400,
  eccentricity: 0.2248,
  trueAnomaly: 0,
  meanAnomaly: 188.1,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const TRINCULO: CelestialBody = {
  id: 'trinculo',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.39e16,
  radius: 9,
  semiMajorAxis: 8505200,
  eccentricity: 0.2194,
  trueAnomaly: 0,
  meanAnomaly: 194.9,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const SYCORAX: CelestialBody = {
  id: 'sycorax',
  position: {
    x: 0,
    y: 0
  },
  mass: 230e16,
  radius: 78.5,
  semiMajorAxis: 12179400,
  eccentricity: 0.5219,
  trueAnomaly: 0,
  meanAnomaly: 260.9,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const MARGARET: CelestialBody = {
  id: 'margaret',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.54e16,
  radius: 10,
  semiMajorAxis: 14146700,
  eccentricity: 0.6772,
  trueAnomaly: 0,
  meanAnomaly: 3.5,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const PROSPERO: CelestialBody = {
  id: 'prospero',
  position: {
    x: 0,
    y: 0
  },
  mass: 8.5e16,
  radius: 25,
  semiMajorAxis: 16276800,
  eccentricity: 0.4445,
  trueAnomaly: 0,
  meanAnomaly: 316.8,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const SETEBOS: CelestialBody = {
  id: 'setebos',
  position: {
    x: 0,
    y: 0
  },
  mass: 7.5e16,
  radius: 24,
  semiMajorAxis: 17420400,
  eccentricity: 0.5908,
  trueAnomaly: 0,
  meanAnomaly: 247.6,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const FERDINAND: CelestialBody = {
  id: 'ferdinand',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.54e16,
  radius: 10,
  semiMajorAxis: 20430000,
  eccentricity: 0.3993,
  trueAnomaly: 0,
  meanAnomaly: 216.4,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const URANUS: CelestialBody = {
  id: 'uranus',
  position: {
    x: 0,
    y: 0
  },
  speed: 6.80,
  mass: 8.6810e25,
  radius: 25362,
  semiMajorAxis: 2875040000,
  eccentricity: 0.046381,
  trueAnomaly: 0,
  meanAnomaly: 142.2386,
  longitudeOfAscendingNode: 74.006,
  type: CelestialBodyType.PLANET,
  satellites: [
    CORDELIA,
    OPHELIA,
    BIANCA,
    CRESSIDA,
    DESDEMONA,
    JULIET,
    PORTIA,
    ROSALIND,
    CUPID,
    BELINDA,
    PERDITA,
    PUCK,
    MAB,
    MIRANDA,
    ARIEL,
    UMBRIEL,
    TITANIA,
    OBERON,
    FRANCISCO,
    CALIBAN,
    STEPHANO,
    TRINCULO,
    SYCORAX,
    MARGARET,
    PROSPERO,
    SETEBOS,
    FERDINAND
  ],
  rings: [
    { id: 'zeta', radius: 37850, width: 3500, depth: 1 },
    { id: 'six', radius: 41837, width: 2.2, depth: 0.41 },
    { id: 'five', radius: 42234, width: 4.9, depth: 0.91 },
    { id: 'four', radius: 42570, width: 4.4, depth: 0.71 },
    { id: 'alpha', radius: 44718, width: 10, depth: 3.39 },
    { id: 'beta', radius: 45661, width: 11.4, depth: 2.14 },
    { id: 'eta', radius: 47175, width: 2.7, depth: 0.42 },
    { id: 'gamma', radius: 47627, width: 4.7, depth: 3.3 },
    { id: 'delta', radius: 48300, width: 6.1, depth: 2.2 },
    { id: 'lambda', radius: 50023, width: 2, depth: 0.2 },
    { id: 'epsilon', radius: 51149, width: 96.4, depth: 47 },
    { id: 'nu', radius: 66100, width: 3800, depth: 0.012 },
    { id: 'mu', radius: 86000, width: 17000, depth: 0.14 }
  ],
  orbitBody: null
};

URANUS.satellites.forEach(satellite => satellite.orbitBody = URANUS);
